import { WithTranslation } from 'react-i18next';

export enum UserRoles {
  EVENT_PARTICIPANT = 'EVENT_PARTICIPANT',
  WORLD_ADMIN = 'WORLD_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  FACILITATOR = 'FACILITATOR',
  COORDINATOR = 'COORDINATOR',
}

export interface IMultiRoleModalView extends WithTranslation {
  onClick: (isTrainer?: boolean) => void;
}
